import React, { useState, useEffect, useRef } from "react";
import './Exclusives.css'
import ESPNExclusive from './../../../../images/espnexclusive.png'
import AppleMusicExclusive from './../../../../images/applemusicexclusive.png'
import N3rveProPopup from './../../../../images/n3rvepropopup.png'
import CrossIcon from './../../../../images/crossicon.png'
import NbaExclusive from './../../../../images/nbaexclusive.png'
import TwitchExclusive from './../../../../images/twitchexclusive.png'
import OteExclusive from './../../../../images/oteexclusive.png'
import ExclusiveDesc from './ExclusiveDesc'
import ExclusiveComingSoonImg from './../../../../images/exclusivecomingsoonimg.png'
import NerveProOnly from './../../../../images/nerveproonlytag.png'
import BackIcon from './../../../../images/backicon.png'
import ESPNBanner from './../../../../images/espnbanner.png'
import AppleMusicBanner from './../../../../images/applemusicbanner.png'
import GreenCheckCircle from './../../../../images/greencheckcircle.png'
import crossicon from './../../../../images/crossicon.png'
import paymentinfoicon from './../../../../images/paymentinfobtn.png'
import albumexampleimg2 from './../../../../images/albumexampleimg2.png'
import submittackpopupback from './../../../../images/submittrackpopupback.png'
import justatick from './../../../../images/justatick.png'
import ReactModal from 'react-modal';
import Checkbox, { checkboxClasses } from '@mui/material/Checkbox';
import CircularProgress from '@mui/material/CircularProgress';
import requestsubmittedicon from './../../../../images/requestsubmittedicon.png'
import congrats from './../../../../images/welldonemove.png'
import jpcongrats from './../../../../images/jp-welldonemove.png'
import confetti from './../../../../images/confetti.png'
import { Trans, useTranslation } from 'react-i18next'
import i18next from "i18next"
import Cookies from 'universal-cookie';
import { useJwt, decodeToken } from "react-jwt";
import { logtoWix } from "../../../Helpers/LogToWix";


function Exclusives({ nav, hidedashboard }) {
    const [ExclusiveDetails, setExclusiveDetails] = useState(false)
    const [ExclusiveComingSoon, setExclusiveComingSoon] = useState(false)
    const [DetailsDrawer, setDetailsDrawer] = useState(0)
    const [popupopen, setPopupopen] = useState(false)
    const [STPopup1, setSTPopup1] = useState(false)
    const [STPopup2, setSTPopup2] = useState(false)
    const [agreetoTaC, setAgreeToTaC] = useState(false)
    const [toogleTrackMenu, setToggleTrackMenu] = useState(false)
    const [trackSelect, settrackSelect] = useState(0)
    const [timeLeft, setTimeLeft] = useState(null);
    const [PSPopup3, setPSPopup3] = useState(false)
    const ref = useRef(null)
    const [height, setHeight] = useState(document.body.scrollHeight)
    const { t, i18n } = useTranslation();
    const cookies = new Cookies(null, { path: '/' });
    const [bannerImage, setBannerImage] = useState(ESPNBanner)
    const [bannerHeader, setBannerHeader] = useState("")
    const hasLogged = useRef(false);


    useEffect(() => {
        // setHeight(ref.current.clientHeight);
        topFunction();
        nav("Exclusives")
        hidedashboard(true)

        if (!hasLogged.current) {
            if (cookies.get('token') !== undefined) {
                if (decodeToken(cookies.get('token')) !== null) {
                    logtoWix(decodeToken(cookies.get('token')).email, "pageview", "Artist Dashboard Exclusives Page", { "desc": "User opened the artist dashboard exclusives page" })
                    hasLogged.current = true;
                } else {
                    logtoWix("anonymous user", "pageview", "Artist Dashboard Exclusives Page", { "desc": "User opened the artist dashboard exclusives page" })
                    hasLogged.current = true;
                }
            } else {
                logtoWix("anonymous user", "pageview", "Artist Dashboard Exclusives Page", { "desc": "User opened the artist dashboard exclusives page" })
                hasLogged.current = true;
            }
        }

    }, [])

    useEffect(() => {
        // setHeight(ref.current.clientHeight);
        topFunction();
    }, [bannerHeader])


    function topFunction() {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }

    useEffect(() => {
        // exit early when we reach 0
        if (!timeLeft) return;

        if (timeLeft === 1) {
            console.log("TIME LEFT IS 1");
            setSTPopup2(false)
            setPSPopup3(true)
        }

        if (timeLeft === 0) {
            console.log("TIME LEFT IS 0");
            setTimeLeft(null)
        }

        // save intervalId to clear the interval when the
        // component re-renders
        const intervalId = setInterval(() => {

            setTimeLeft(timeLeft - 1);
        }, 1000);

        // clear interval on re-render to avoid memory leaks
        return () => clearInterval(intervalId);
        // add timeLeft as a dependency to re-rerun the effect
        // when we update it
    }, [timeLeft]);

    function closeSTPopup1() {
        setSTPopup1(false)
    }


    function closePSPopup3() {
        setPSPopup3(false)
    }

    function closeSTPopup2() {
        setSTPopup2(false)
    }

    function closeProPopup() {
        setPopupopen(false)
    }

    return (
        <div style={{ minHeight: '100vh', height: 'auto', backgroundImage: 'linear-gradient(180deg, rgba(117, 240, 233, 0) 39.98%, rgba(117, 240, 233, 0.0670806) 51.55%, #75F0E9 163.41%)', paddingBottom: '-10em', marginBottom: '-5em' }}>
            <ReactModal
                isOpen={STPopup1}
                contentLabel="Example Modal"
                className="SubmitTrackPopup1Container"
                overlayClassName="Overlay"
                onRequestClose={closeSTPopup1} // closes the modal when the user presses the escape key
                shouldCloseOnOverlayClick={true} // closes the modal when the user clicks outside of it
                style={{
                    content: {
                        width: '38.812em',
                        height: '46.5em',
                        margin: 'auto',
                        backgroundImage: 'linear-gradient(7.87deg, #182028 50.13%, #273644 96.12%)',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        borderRadius: '8px',
                        border: '0.5px solid rgba(255,255,255,25%)'
                    }
                }}
            >
                <img src={crossicon} style={{ height: '1.5em', width: '1.5em', position: 'absolute', right: '1.5em', top: '1.5em', cursor: 'pointer' }} onClick={() => setSTPopup1(false)} />
                <div className="STPopupHeader">{t('Submityourtrack')}</div>

                {
                    !toogleTrackMenu &&
                    <div style={{ width: "90%" }}>
                        <div className="STPopupInfo">{t('Selectthetracktosub')}</div>
                        <div style={{ display: 'flex', flexDirection: 'column', width: '90%' }}>
                            <div style={{ display: 'flex', flexDirection: 'row', width: '90%', alignSelf: 'center', alignItems: 'center', justifyContent: 'space-between', marginBottom: '1em', marginTop: '1em', cursor: 'pointer' }} onClick={() => setToggleTrackMenu(!toogleTrackMenu)}>
                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                    <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/dkyvvtdtsyctuil9zpbj"} style={{ width: '6.25em', height: '6.25em', marginRight: '0.68em' }} />
                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                        <div className="STAlbumTxt">{t('Album')}</div>
                                        <div className="STAlbumName">Vivid Reflection</div>
                                        <div className="STAlbumTracks">3 Tracks</div>
                                    </div>
                                </div>
                                <img src={paymentinfoicon} style={{ width: '0.66em', height: '1.16em' }} />
                            </div>

                            <div style={{ display: 'flex', flexDirection: 'row', width: '90%', alignSelf: 'center', alignItems: 'center', justifyContent: 'space-between', cursor: 'pointer' }} onClick={() => setToggleTrackMenu(!toogleTrackMenu)}>
                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                    <img src={albumexampleimg2} style={{ width: '6.25em', height: '6.25em', marginRight: '0.68em' }} />
                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                        <div className="STAlbumTxt">{t('Album')}</div>
                                        <div className="STAlbumName">Don't Waste A Minute</div>
                                        <div className="STAlbumTracks">9 Tracks</div>
                                    </div>
                                </div>
                                <img src={paymentinfoicon} style={{ width: '0.66em', height: '1.16em' }} />
                            </div>
                        </div>
                    </div>
                }

                {
                    toogleTrackMenu &&
                    <div style={{ width: "90%" }}>
                        <div className="STPopupInfo">{t('Whichsongswouldyouliketosubmit')}</div>
                        <img src={submittackpopupback} style={{ cursor: 'pointer' }} onClick={() => setToggleTrackMenu(!toogleTrackMenu)} />
                        <div style={{ display: 'flex', flexDirection: 'column', width: '90%', alignItems: 'center' }}>
                            <div style={{ display: 'flex', flexDirection: 'row', width: '90%', alignSelf: 'center', alignItems: 'center', justifyContent: 'space-between', marginBottom: '1em', marginTop: '1em', cursor: 'pointer' }} onClick={() => setToggleTrackMenu(!toogleTrackMenu)}>
                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                    <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/dkyvvtdtsyctuil9zpbj"} style={{ width: '6.25em', height: '6.25em', marginRight: '0.68em' }} />
                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                        <div className="STAlbumTxt">{t('Album')}</div>
                                        <div className="STAlbumName">Vivid Reflection</div>
                                        <div className="STAlbumTracks">3 Tracks</div>
                                    </div>
                                </div>

                            </div>

                            {
                                trackSelect === 1 &&
                                <div style={{ display: 'flex', flexDirection: 'column', width: '100%', marginLeft: '1.5em' }}>
                                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', width: '85%', backgroundColor: 'rgba(233,19,83,65%)', paddingTop: '1em', marginBottom: '0.88em', paddingLeft: '1.5em', paddingRight: '1.5em', borderRadius: '8px' }}>
                                        <div className="SubmitTrackTxt">1.  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Ripple</div>
                                        <img src={justatick} style={{ width: '1em', height: '0.68em', marginTop: '-0.5em' }} />
                                    </div>
                                    <div className="SubmitTrackTxt" style={{ marginLeft: '1.3em' }} onClick={() => settrackSelect(2)}>2.  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Echoes of Yesterday</div>
                                </div>
                            }

                            {
                                trackSelect === 2 &&
                                <div style={{ display: 'flex', flexDirection: 'column', width: '100%', marginLeft: '1.5em' }}>
                                    <div className="SubmitTrackTxt" style={{ marginLeft: '1.3em' }} onClick={() => settrackSelect(1)}>1.  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Ripple</div>
                                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', width: '85%', backgroundColor: 'rgba(233,19,83,65%)', paddingTop: '1em', marginBottom: '0.88em', paddingLeft: '1.5em', paddingRight: '1.5em', borderRadius: '8px' }}>
                                        <div className="SubmitTrackTxt">2.  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Echoes of Yesterday</div>
                                        <img src={justatick} style={{ width: '1em', height: '0.68em', marginTop: '-0.5em' }} />
                                    </div>

                                </div>
                            }

                            {
                                trackSelect === 0 &&
                                <div style={{ display: 'flex', flexDirection: 'column', width: '100%', marginLeft: '4.5em' }}>
                                    <div className="SubmitTrackTxt" onClick={() => settrackSelect(1)}>1.  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Ripple</div>
                                    <div className="SubmitTrackTxt" onClick={() => settrackSelect(2)}>2.  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Echoes of Yesterday</div>

                                </div>
                            }





                            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '85%' }}>
                                <div className="SubmitTrackTxt" style={{ color: 'rgba(254,254,254,50%)' }}>3.  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Twist</div>
                                <div className="TrackSubmittedTxt">{t('Trackalreadysubmitted')}</div>
                            </div>
                        </div>
                    </div>
                }


                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: '1.5em', width: '90%' }}>
                    <Checkbox checked={agreetoTaC} onChange={() => setAgreeToTaC(!agreetoTaC)}
                        iconStyle={{ fill: '#FFFFFF' }}
                        sx={{
                            [`&, &.${checkboxClasses.checked}`]: {
                                color: '#FFFFFF',
                            },
                            color: "#E91353",
                            '&.Mui-checked': {
                                color: "#E91353"
                            }
                        }}
                    />
                    <span className="AgreeToTaCTxt">
                        <Trans i18nKey="Iagreetotandc" >
                            I agree to the <span style={{ color: '#C7A5FF' }}>terms & conditions</span>
                        </Trans>

                    </span>
                </div>

                <div style={{ display: 'flex', flexDirection: 'row', marginTop: '1.5em' }}>
                    <div className="PresavePopup2CancelBtn" onClick={() => setSTPopup1(false)}>
                        {t('Cancel')}
                    </div>

                    {
                        agreetoTaC && trackSelect !== 0 &&
                        <div className="PresavePopup1SubmitBtn" onClick={() => { setSTPopup1(false); setSTPopup2(true); setTimeLeft(5) }}>
                            {t('Submit')}
                        </div>
                    }

                    {
                        (!agreetoTaC || trackSelect === 0) &&
                        <div className="PresavePopup1SubmitBtn" style={{ backgroundColor: '#821D41', color: '#8D9297', cursor: 'auto' }}>
                            {t('Submit')}
                        </div>
                    }

                </div>
            </ReactModal>

            <ReactModal
                isOpen={PSPopup3}
                contentLabel="Example Modal"
                className="PresavePopup3Container"
                overlayClassName="Overlay"
                onRequestClose={closePSPopup3} // closes the modal when the user presses the escape key
                shouldCloseOnOverlayClick={true} // closes the modal when the user clicks outside of it
            >
                <img src={requestsubmittedicon} style={{ width: '2.62em', height: '2.62em', marginTop: '2em' }} />
                <div className="RSPopupHeader">{t('Submitted!')}</div>
                {
                    cookies.get('lang') === 'en' &&
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', marginTop: '1em' }}>
                        <img src={confetti} />
                        <div className="CongratsMessage">Well done, you've made your move!</div>
                    </div>

                }

                {
                    cookies.get('lang') === 'jp' &&
                    <img src={jpcongrats} style={{ marginTop: '1em' }} />
                }


                <div className="RSPopupInfo" style={{ fontSize: '1em', paddingLeft: '1em', paddingRight: '2.5em', paddingLeft: '2.5em', textAlign: 'left' }}>
                    {t('Yourtrackhasbeen!')}</div>
                <div className="PresavePopup1ContinueBtn" onClick={() => { setPSPopup3(false) }} style={{ cursor: 'pointer' }}>
                    {t('Done')}
                </div>
            </ReactModal>


            <ReactModal
                isOpen={STPopup2}
                contentLabel="Example Modal"
                className="SubmitTrackPopup2Container"
                overlayClassName="Overlay"
                onRequestClose={closeSTPopup2} // closes the modal when the user presses the escape key
                shouldCloseOnOverlayClick={true} // closes the modal when the user clicks outside of it
                style={{
                    content: {
                        width: '38.812em',
                        height: '46.5em',
                        margin: 'auto',
                        backgroundImage: 'linear-gradient(7.87deg, #182028 50.13%, #273644 96.12%)',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        borderRadius: '8px',
                        border: '0.5px solid rgba(255,255,255,25%)'
                    }
                }}
            >
                <img src={crossicon} style={{ height: '1.5em', width: '1.5em', position: 'absolute', right: '1.5em', top: '1.5em', cursor: 'pointer' }} />
                <div className="STPopupHeader">{t('Submityourtrack')}</div>

                {
                    !toogleTrackMenu &&
                    <div style={{ width: "90%" }}>
                        <div className="STPopupInfo">{t('Selectthetracktosub')}</div>
                        <div style={{ display: 'flex', flexDirection: 'column', width: '90%' }}>
                            <div style={{ display: 'flex', flexDirection: 'row', width: '90%', alignSelf: 'center', alignItems: 'center', justifyContent: 'space-between', marginBottom: '1em', marginTop: '1em', cursor: 'pointer' }} onClick={() => setToggleTrackMenu(!toogleTrackMenu)}>
                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                    <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/dkyvvtdtsyctuil9zpbj"} style={{ width: '6.25em', height: '6.25em', marginRight: '0.68em' }} />
                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                        <div className="STAlbumTxt">{t('Album')}</div>
                                        <div className="STAlbumName">Vivid Reflection</div>
                                        <div className="STAlbumTracks">3 Tracks</div>
                                    </div>
                                </div>
                                <img src={paymentinfoicon} style={{ width: '0.66em', height: '1.16em' }} />
                            </div>

                            <div style={{ display: 'flex', flexDirection: 'row', width: '90%', alignSelf: 'center', alignItems: 'center', justifyContent: 'space-between', cursor: 'pointer' }} onClick={() => setToggleTrackMenu(!toogleTrackMenu)}>
                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                    <img src={albumexampleimg2} style={{ width: '6.25em', height: '6.25em', marginRight: '0.68em' }} />
                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                        <div className="STAlbumTxt">{t('Album')}</div>
                                        <div className="STAlbumName">Don't Waste A Minute</div>
                                        <div className="STAlbumTracks">9 Tracks</div>
                                    </div>
                                </div>
                                <img src={paymentinfoicon} style={{ width: '0.66em', height: '1.16em' }} />
                            </div>
                        </div>
                    </div>
                }

                {
                    toogleTrackMenu &&
                    <div style={{ width: "90%" }}>
                        <div className="STPopupInfo">{t('Whichsongswouldyouliketosubmit')}</div>
                        <img src={submittackpopupback} style={{ cursor: 'pointer' }} onClick={() => setToggleTrackMenu(!toogleTrackMenu)} />
                        <div style={{ display: 'flex', flexDirection: 'column', width: '90%', alignItems: 'center' }}>
                            <div style={{ display: 'flex', flexDirection: 'row', width: '90%', alignSelf: 'center', alignItems: 'center', justifyContent: 'space-between', marginBottom: '1em', marginTop: '1em', cursor: 'pointer' }} onClick={() => setToggleTrackMenu(!toogleTrackMenu)}>
                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                    <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/dkyvvtdtsyctuil9zpbj"} style={{ width: '6.25em', height: '6.25em', marginRight: '0.68em' }} />
                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                        <div className="STAlbumTxt">{t('Album')}</div>
                                        <div className="STAlbumName">Vivid Reflection</div>
                                        <div className="STAlbumTracks">3 Tracks</div>
                                    </div>
                                </div>

                            </div>

                            {
                                trackSelect === 1 &&
                                <div style={{ display: 'flex', flexDirection: 'column', width: '100%', marginLeft: '1.5em' }}>
                                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', width: '85%', backgroundColor: 'rgba(233,19,83,65%)', paddingTop: '1em', marginBottom: '0.88em', paddingLeft: '1.5em', paddingRight: '1.5em', borderRadius: '8px' }}>
                                        <div className="SubmitTrackTxt">1.  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Ripple</div>
                                        <img src={justatick} style={{ width: '1em', height: '0.68em', marginTop: '-0.5em' }} />
                                    </div>
                                    <div className="SubmitTrackTxt" style={{ marginLeft: '1.3em' }} onClick={() => settrackSelect(2)}>2.  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Echoes of Yesterday</div>
                                </div>
                            }

                            {
                                trackSelect === 2 &&
                                <div style={{ display: 'flex', flexDirection: 'column', width: '100%', marginLeft: '1.5em' }}>
                                    <div className="SubmitTrackTxt" style={{ marginLeft: '1.3em' }} onClick={() => settrackSelect(1)}>1.  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Ripple</div>
                                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', width: '85%', backgroundColor: 'rgba(233,19,83,65%)', paddingTop: '1em', marginBottom: '0.88em', paddingLeft: '1.5em', paddingRight: '1.5em', borderRadius: '8px' }}>
                                        <div className="SubmitTrackTxt">2.  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Echoes of Yesterday</div>
                                        <img src={justatick} style={{ width: '1em', height: '0.68em', marginTop: '-0.5em' }} />
                                    </div>

                                </div>
                            }

                            {
                                trackSelect === 0 &&
                                <div style={{ display: 'flex', flexDirection: 'column', width: '100%', marginLeft: '4.5em' }}>
                                    <div className="SubmitTrackTxt" onClick={() => settrackSelect(1)}>1.  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Ripple</div>
                                    <div className="SubmitTrackTxt" onClick={() => settrackSelect(2)}>2.  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Echoes of Yesterday</div>

                                </div>
                            }





                            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '85%' }}>
                                <div className="SubmitTrackTxt" style={{ color: 'rgba(254,254,254,50%)' }}>3.  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Twist</div>
                                <div className="TrackSubmittedTxt">{t('Trackalreadysubmitted')}</div>
                            </div>
                        </div>
                    </div>
                }


                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: '1.5em', width: '90%' }}>
                    <Checkbox checked={agreetoTaC} onChange={() => setAgreeToTaC(!agreetoTaC)}
                        iconStyle={{ fill: '#FFFFFF' }}
                        sx={{
                            [`&, &.${checkboxClasses.checked}`]: {
                                color: '#FFFFFF',
                            },
                            color: "#E91353",
                            '&.Mui-checked': {
                                color: "#E91353"
                            }
                        }}
                    />
                    <span className="AgreeToTaCTxt">
                        <Trans i18nKey="Iagreetotandc" >
                            I agree to the <span style={{ color: '#C7A5FF' }}>terms & conditions</span>
                        </Trans>

                    </span>
                </div>

                <CircularProgress style={{ position: 'absolute', marginTop: '13em', width: '5em', height: '5em' }} sx={{ color: '#FFFFFF' }} />

                <div style={{ display: 'flex', flexDirection: 'row', marginTop: '1.5em' }}>
                    <div className="PresavePopup2CancelBtn">
                        {t('Cancel')}
                    </div>

                    <div className="PresavePopup1SubmitBtn">
                        {t('Submit')}
                    </div>
                </div>
            </ReactModal>




            <ReactModal
                isOpen={popupopen}
                contentLabel="Example Modal"
                overlayClassName="Overlay"
                onRequestClose={closeProPopup} // closes the modal when the user presses the escape key
                shouldCloseOnOverlayClick={true} // closes the modal when the user clicks outside of it
                style={{
                    content: {
                        width: '38.812em',
                        height: '46.5em',
                        margin: 'auto',
                        backgroundImage: 'linear-gradient(7.87deg, #182028 50.13%, #273644 96.12%)',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        borderRadius: '8px',
                        border: '0.5px solid rgba(255,255,255,25%)'
                    }
                }}
            >
                <img src={N3rveProPopup} alt="Man with headphones" style={{ width: '38.812em', height: '14.625em', marginTop: '-2em' }} />
                <img src={CrossIcon} alt="White Cross" style={{ position: 'absolute', right: '2em', top: '1em', cursor: 'pointer' }} onClick={() => setPopupopen(false)} />
                <div className="PopupHeader">  <Trans i18nKey="Unlockpropower" components={{ 1: <br /> }} >
                    Unlock Pro Power, Elevate Your Artistry
                </Trans> </div>
                <div className="PopupDesc">
                    <Trans i18nKey="Unleashexclusivefeatures" components={{ 1: <br /> }} >
                        Unleash exclusive features, propelling your artistry beyond limits, and <br /> nurture your journey towards unparalleled success!
                    </Trans></div>

                <div style={{
                    width: '90%',
                    backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)',
                    paddingTop: '1.5em',
                    paddingBottom: '1.5em',
                    borderRadius: '8px',
                    display: 'flex',
                    flexDirection: 'column'
                }}>
                    <div style={{ alignSelf: 'center' }}>
                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '0.5em' }}>
                            <img src={GreenCheckCircle} style={{ height: '1.25em', width: '1.25em', marginRight: '0.625em' }} />
                            <div className="PopupListItem">{t('Includesallbenefits')}Includes all benefits from Nerve Plus</div>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '0.5em' }}>
                            <img src={GreenCheckCircle} style={{ height: '1.25em', width: '1.25em', marginRight: '0.625em' }} />
                            <div className="PopupListItem">{t('Unlimiteddsprel')}</div>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '0.5em' }}>
                            <img src={GreenCheckCircle} style={{ height: '1.25em', width: '1.25em', marginRight: '0.625em' }} />
                            <div className="PopupListItem">{t('Youtubemonetize')}</div>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                            <img src={GreenCheckCircle} style={{ height: '1.25em', width: '1.25em', marginRight: '0.625em' }} />
                            <div className="PopupListItem">{t('Exclusivebranddeals')}</div>
                        </div>
                    </div>
                </div>

                <div className="PopupPrice">{t('12months49')}</div>
                <div className="PopupDesc">{t('Youcancancel')}</div>

                <div className="UpgradetoProBtn" >{t('Upgradetopro')}</div>
            </ReactModal>

            {
                ExclusiveComingSoon &&
                <div className="ExclusiveContainer" style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                    <img src={ExclusiveComingSoonImg} style={{ width: '21.68em', height: '18.25em', marginTop: '9.85em' }} />
                    <img src={NerveProOnly} style={{ width: '9.375em', height: '2em' }} />
                    <div className="ExclusiveCmgSoonHeader">Exclusive Coming Soon...</div>
                    <div className="ExclusiveCmgSoonInfo">Check back soon to get exclusive sync deals, brand partnership and<br /> perks on N3RVE. </div>
                </div>
            }

            {
                !ExclusiveDetails &&
                !ExclusiveComingSoon &&
                <div className="ExclusiveContainer">

                    <div className="ExclusiveTitleTxt">
                        {t('Exclusiveheader')}
                    </div>

                    <div className="ExclusivesHeader">
                        <div className="NerveProButton"> {t('Nerveproonly')}</div>
                        <div className="ExclusiveDiv1Header"> <Trans i18nKey="Getexclusivesyncdeals" components={{ 1: <br /> }} >
                            Get exclusive sync deals,<br /> Brand Partnership and Perks
                        </Trans></div>
                        <div className="ExclusiveDiv1Desc"> {t('Upyourgamereachnewfans')} </div>
                    </div>


                    <div className="Header">
                        <div className="HeaderColumn1">
                            <div className="ExclusiveWidgetHeader">{t('GetyourmusiconESPN')}</div>
                            <div className="ExclusiveWidgetDesc">{t('Nerveandespnarelooking')}</div>
                            <div className="SubmitTrackBtn" onClick={() => { setBannerHeader("Get your Music on ESPN"); setBannerImage(ESPNBanner); setExclusiveDetails(true); topFunction(); setDetailsDrawer(0) }} style={{ cursor: 'pointer' }}>{t('Submityourtrack')}</div>
                        </div>

                        <div className="HeaderColumn2">
                            <img src={ESPNExclusive} alt="Espn Exclusive Logo" />
                        </div>
                    </div>

                    {
                        cookies.get('lang') === 'en' &&
                        <div className="Header">
                            <div className="HeaderColumn1">
                                <div className="ExclusiveWidgetHeader">Submit your music to have it featured on live streams
                                    around the world</div>
                                <div className="ExclusiveWidgetDesc">N3RVE has partnered with Apple Music and the NBA to create the biggest playlist for independent artists.</div>
                                <div className="SubmitTrackBtn" onClick={() => { setBannerHeader("Submit your music to have it featured on live streams around the world"); setBannerImage(AppleMusicBanner); setExclusiveDetails(true); topFunction(); setDetailsDrawer(0) }} style={{ cursor: 'pointer' }}>Submit Your Track</div>
                            </div>

                            <div className="HeaderColumn2">
                                <img src={AppleMusicExclusive} alt="Apple Exclusive Logo" />
                            </div>
                        </div>
                    }

                    {
                        cookies.get('lang') === 'en' &&
                        <div className="Header">
                            <div className="HeaderColumn1">
                                <div className="ExclusiveWidgetHeader">Get your music into the NBA</div>
                                <div className="ExclusiveWidgetDesc">Join our exclusive partnership with the NBA for a chance to get your music featured across league, team, and player socials + NBA TV, the NBA app, nba.com, and more. </div>
                                <div className="SubmitTrackBtn" onClick={() => { setBannerHeader("Get your music into the NBA"); setExclusiveDetails(true); topFunction(); setDetailsDrawer(0) }} style={{ cursor: 'pointer' }}>Submit Your Track</div>
                            </div>

                            <div className="HeaderColumn2">
                                <img src={NbaExclusive} alt="NBA Exclusive Logo" />
                            </div>
                        </div>
                    }

                    {
                        cookies.get('lang') === 'en' &&
                        <div className="Header">
                            <div className="HeaderColumn1">
                                <div className="ExclusiveWidgetHeader">New Application Now open - Apply for The Collective</div>
                                <div className="ExclusiveWidgetDesc">Receive priority consideration to join The Collective's new co-op, presented by Twitch. N3RVE and Twitch are partnering up for Twitch’s music incubator program, “The Collective”. Selected users will be invited to join a curated invite-only cohort and work together with the Twitch music team and industry mentors to build engaged communities. N3RVE artists will get priority consideration and once successfully in The Collective, you will have opportunities to earn money directly from fans on Twitch as well as ongoing backing and prioritized discovery, promotion, and activations from Twitch, Amazon Music and Rolling Stone.</div>
                                <div className="SubmitTrackBtn" onClick={() => { setBannerHeader("New Application Now open - Apply for The Collective"); setExclusiveDetails(true); topFunction(); setDetailsDrawer(0) }} style={{ cursor: 'pointer' }}>Submit Your Track</div>
                            </div>

                            <div className="HeaderColumn2">
                                <img src={TwitchExclusive} alt="Twitch Exclusive Logo" />
                            </div>
                        </div>
                    }

                    {
                        cookies.get('lang') === 'en' &&
                        <div className="Header">
                            <div className="HeaderColumn1">
                                <div className="ExclusiveWidgetHeader">Be soundtracked with Overtime Elite</div>
                                <div className="ExclusiveWidgetDesc">Submit your music for consideration for placement in Overtime Elite’s social media and digital marketing campaigns, as well as featured in OTE’s in-stadium experience. OTE is a transformative new sports league that offers the world’s most talented young basketball players a better pathway to becoming professional athletes and engage and inspire a new generation of fans.</div>
                                <div className="SubmitTrackBtn" onClick={() => { topFunction(); setBannerHeader("Be soundtracked with Overtime Elite"); setExclusiveDetails(true); setDetailsDrawer(0) }} style={{ cursor: 'pointer' }}>Submit Your Track</div>
                            </div>

                            <div className="HeaderColumn2">
                                <img src={OteExclusive} alt="OTE Exclusive Logo" />
                            </div>
                        </div>
                    }

                </div>
            }


            {
                ExclusiveDetails &&
                !ExclusiveComingSoon &&

                <div className="ExclusiveDescContainer">

                    <div className="BackBtn" onClick={() => setExclusiveDetails(false)} style={{ cursor: 'pointer' }}>
                        <img src={BackIcon} alt="back arrow" style={{ width: '1.5em', height: '1.5em' }} />
                        <div className="Backtxt">{t('Back')}</div>
                    </div>

                    <img src={bannerImage} alt="ESPN Banner" style={{ width: '100%', marginTop: '1em' }} />

                    <div className="ExclusiveBrand" style={{ width: '55%' }}>
                        {bannerHeader}
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'row', marginTop: '1em', marginLeft: '2.5em' }}>
                        {
                            DetailsDrawer === 0 &&
                            <div className="HighlightedDrawOption" onClick={() => setDetailsDrawer(0)} style={{ cursor: 'pointer' }}>{t('About')}</div>
                        }

                        {
                            DetailsDrawer !== 0 &&
                            <div className="DrawOption" onClick={() => setDetailsDrawer(0)} style={{ cursor: 'pointer' }}>{t('About')}</div>
                        }

                        {
                            DetailsDrawer === 1 &&
                            <div className="HighlightedDrawOption" onClick={() => setDetailsDrawer(1)} style={{ cursor: 'pointer' }}>{t('Terms')}</div>
                        }

                        {
                            DetailsDrawer !== 1 &&
                            <div className="DrawOption" onClick={() => setDetailsDrawer(1)} style={{ cursor: 'pointer' }}>{t('Terms')}</div>
                        }

                        {
                            DetailsDrawer === 2 &&
                            <div className="HighlightedDrawOption" onClick={() => setDetailsDrawer(2)} style={{ cursor: 'pointer' }}>{t('Submission')}</div>
                        }

                        {
                            DetailsDrawer !== 2 &&
                            <div className="DrawOption" onClick={() => setDetailsDrawer(2)} style={{ cursor: 'pointer' }}>{t('Submission')}</div>
                        }

                    </div>

                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                        <div style={{ width: '45.97%', backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)', borderRadius: '8px', marginLeft: '2.5em', marginTop: '1.5em', paddingTop: '1.5em', paddingBottom: '1.5em' }}>
                            {
                                DetailsDrawer === 0 && bannerImage !== AppleMusicBanner &&
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <div className="AboutDrawerDesc">
                                        {t('Submityourtrackfor')}

                                    </div>

                                    <div className="AboutDrawerHeader">
                                        <br />{t('Selectedartistwillreceive')}
                                    </div>
                                    <div className="AboutDrawerDesc">
                                        &#8226; &nbsp; {t('Placementinespncontent')} <br />
                                        &#8226; &nbsp; {t('Potentialfeatuesonunitedmasters')}
                                    </div>

                                    <div className="AboutDrawerHeader">
                                        <br />  {t('Requirementsheader')}
                                    </div>

                                    <div className="AboutDrawerDesc">
                                        {t('Songsselectedbynervemust')}
                                    </div>


                                    <div className="AboutDrawerHeader">
                                        <br />  {t('Brandintegrityandcompliance')}
                                    </div>

                                    <div className="AboutDrawerDesc">
                                        {t('Pleaseaviodexplicitreference')}

                                    </div>


                                </div>
                            }

                            {
                                DetailsDrawer === 0 && bannerImage === AppleMusicBanner &&
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <div className="AboutDrawerDesc">
                                        {t('Ourpartnershipwithapplemusic')}
                                    </div>

                                    <div className="AboutDrawerHeader">
                                        <br />{t('Selectedartistwillreceive')}
                                    </div>
                                    <div className="AboutDrawerDesc">
                                        &#8226; &nbsp;{t('Featuredplacementonbaseline')}
                                        <br />
                                        &#8226; &nbsp; {t('Editorialcoverageandpromo')}
                                        <br />
                                        &#8226; &nbsp; {t('Revenuesplitwillnotchange')}

                                    </div>

                                    <div className="AboutDrawerHeader">
                                        <br /> {t('Requirementsheader')}
                                    </div>

                                    <div className="AboutDrawerDesc">
                                        {t('Songsselectedbynervemustbe')}
                                    </div>

                                    <div className="AboutDrawerHeader">
                                        <br />{t('Baselinebrandintegrity')}
                                    </div>

                                    <div className="AboutDrawerDesc">
                                        {t('Specificreferencestocurrent')}


                                    </div>

                                    <div className="AboutDrawerHeader">
                                        <br /> {t('Notbrandcompliant')}
                                    </div>

                                    {
                                        cookies.get('lang') === 'en' &&
                                        <div className="AboutDrawerDesc">
                                            1. Violence <br />
                                            &#8226; &nbsp; Gun Violence: Lyrics or video footage with communication or illustration of gun violence, including references of historical, “real life” examples, as well as general ideas of completed or planned gun violence, except as used in a purely metaphorical sense. <br />
                                            &#8226; &nbsp; Domestic Violence: Lyrics or video footage with communication or illustration of domestic violence of any kind.<br /><br />

                                            2. Hate<br />
                                            &#8226;&nbsp; Violent or malicious lyrics or video footage motivated by prejudice based on race, gender, religion, sexual orientation, national origin, disability or other protected classes.<br />
                                            &#8226;&nbsp; Lyrics or footage intended to incite hatred or violence against a person or group based on race, gender, religion, sexual orientation, national origin, disability, or other protected classes.<br /><br />

                                            3. Drugs/ Alcohol<br />
                                            &#8226;&nbsp; Explicit or direct references to selling or doing drugs, including alcohol, are not permitted.<br />
                                        </div>
                                    }

                                    {
                                        cookies.get('lang') === 'jp' &&
                                        <div className="AboutDrawerDesc">
                                            暴力 <br />
                                            銃による暴力: 純粋に比喩的な意味で使用される場合を除き、歴史的な「現実の」例への言及、および完了または計画された銃による暴力の一般的なアイデアを含む、銃による暴力のコミュニケーションまたはイラストを含む歌詞またはビデオ映像。
                                            <br />
                                            家庭内暴力: あらゆる種類の家庭内暴力に関するコミュニケーションまたはイラストを含む歌詞またはビデオ映像。
                                            <br />
                                            嫌い<br />
                                            人種、性別、宗教、性的指向、出身国、障害、その他の保護階級に基づく偏見に動機付けられた暴力的または悪意のある歌詞またはビデオ映像。<br />
                                            人種、性別、宗教、性的指向、出身国、障害、その他の保護階級に基づく個人またはグループに対する憎悪や暴力を扇動することを目的とした歌詞や映像。<br />

                                            薬物/アルコール<br />
                                            アルコールを含む薬物の販売または行為への明示的または直接的な言及は許可されません。
                                        </div>
                                    }

                                </div>
                            }

                            {
                                DetailsDrawer === 1 &&
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <div className="AboutDrawerDesc">
                                        The following shall form the first amendment to the Agreement entered into between you and N3RVE (“First Amendment”) by your acceptance of the Terms forming such Agreement, and shall modify such terms and conditions as contained in that Agreement thereof as are necessary to effect the provisions hereof. Capitalized terms used herein but not otherwise defined herein shall have the meanings given to such terms in those Terms. Except as expressly modified by this First Amendment, that Agreement remain in full force and effect pursuant to its terms. All references to the Agreement in other documentation between you and N3RVE shall be deemed to be a reference to the Agreement as amended by this First Amendment. <br />
                                        BY SUBMITTING ANY OF YOUR CONTENT FOR CONSIDERATION PURSUANT TO THE FOLLOWING, YOU AGREE TO THESE TERMS; IF YOU DO NOT AGREE, DO NOT SUBMIT ANY CONTENT FOR SUCH CONSIDERATION.<br />All rights not expressly granted to Users in this First Amendment are hereby reserved by Company.<br />THIRD PARTY OPPORTUNITIES<br />
                                        From time to time, before or during the Distribution Term, Company may enter into one or more agreements with third parties (each, a “Third Party”) pursuant to which Company shall deliver certain master sound recordings for possible use in endorsement and brand integration opportunities (each, a “Third Party Opportunity”) and such Third Parties, as applicable, shall use such master sound recordings in promotional and commercial uses (each, a “Third Party Agreement”). In connection with one or more Third Party Opportunities, and in User’s sole discretion, User may request that some or all of the User Content be submitted to be delivered, in Company’s sole discretion (which discretion may be withheld for any reason), to one or more such Third Parties pursuant to the applicable Third Party Agreement(s) (each such item of User Content that User requests be submitted shall hereinafter be defined as “Submitted Content” whether or not such User Content is actually submitted, and any Submitted Content actually delivered under any Third Party Agreement[s] shall hereinafter be referred to as “Delivered Content”). In any such event, the grant of rights as set forth herein shall be automatically expanded to conform to the terms and conditions of each applicable Third Party Agreement pursuant to which the Submitted Content was submitted, relevant provisions of same shall be shared by Company upon User’s request therefor. Further, upon submission by Company, such rights shall automatically be deemed exclusive, and User shall thereafter no longer have the right to grant any other third parties any rights in or to such User Content for so long as Company retains any rights in and to such User Content.<br />
                                        AMENDMENT TO DISTRIBUTION FEES & ROYALTIES:<br />
                                        Notwithstanding anything contained in the Terms, in connection with any Submitted Content, and in consideration for Company’s consideration of such User Content in connection with any Third Party Opportunity, Company shall be entitled to retain Ten Percent (10%) of all gross royalties, payments or other earnings received by User or by Company on User’s behalf in connection with any Submitted Content, and the term “Distribution Fee” as used herein shall be amended accordingly in connection solely with such Submitted Content. Further, in connection with any Delivered Content, and in consideration for the services provided by Company in connection with any Third Party Opportunity, as applicable, Company shall be entitled to retain Twenty Percent (20%) of all gross royalties, payments or other earnings received by User or by Company on User’s behalf in connection with any Submitted Content, and the term “Distribution Fee” as used herein shall be amended accordingly in connection solely with such Delivered Content.<br />
                                        AMENDMENT TO DISTRIBUTION TERM; TERMINATION AND REMOVAL:<br />
                                        In the event any Submitted Content is delivered to any Third Party pursuant to the terms and conditions hereof, the term of this Agreement shall automatically be extended such that the Distribution Term is coterminous with the term of the applicable Third Party Agreement(s) unless terminated prior to that date in Company’s sole discretion, and shall automatically extend for one (1) month periods thereafter unless and until User provides Company with at least ninety (90) days’ notice of User’s desire to terminate the term of the Agreement in connection therewith, or unless Company sends you written notice of termination at any point. User acknowledges and agrees that, pursuant to any Third Party Agreement(s), Company may agree to and permit the use of such Delivered Content by third parties beyond the term of the Agreement, as amended hereby (including without limitation in perpetuity).<br />
                                        ADDITIONAL USER REPRESENTATION:<br />
                                    </div>

                                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'flex-start', width: '95%', alignSelf: 'center', marginLeft: '2.5em' }}>
                                        <div className="AboutDrawerDesc" style={{ width: '3%', alignSelf: 'flex-start' }}>1.</div>
                                        <div className="AboutDrawerDesc" style={{ width: '90%' }}>User has exclusive copyright rights to any such User Content, in part or in whole, has secured any and all mechanical licenses, digital phonorecord delivery licenses (i.e. DPD licenses) and all other licenses required from musical composition copyright owners, publishers, administrators, artists, producers, copyright owners, master rights owners, and any and all Rights Holders, and has made and will make all payments due (including royalties) in connection with the foregoing licenses referenced in in this subsection and any and all payments that may be required by contract, law, under any collective bargaining agreement, or otherwise to any and all Rights Holders;</div>

                                    </div>

                                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'flex-start', width: '95%', alignSelf: 'center', marginLeft: '2.5em' }}>
                                        <div className="AboutDrawerDesc" style={{ width: '3%', alignSelf: 'flex-start' }}>2.</div>
                                        <div className="AboutDrawerDesc" style={{ width: '90%' }}>User has secured rights from, and shall be solely responsible for paying all monies now or in the future due to any and all Rights Holders (or any other applicable third party) in connection with the User Content and the exploitation of the User Content by Company or any applicable Third Party pursuant to this Agreement, including, without limitation all fees, income, monies, royalties or any other compensation due to Rights Holders;</div>

                                    </div>

                                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'flex-start', width: '95%', alignSelf: 'center', marginLeft: '2.5em' }}>
                                        <div className="AboutDrawerDesc" style={{ width: '3%', alignSelf: 'flex-start' }}>3.</div>
                                        <div className="AboutDrawerDesc" style={{ width: '90%' }}>With respect to the non-dramatic public performance rights to musical compositions contained in each musical compositions embodied in any such User Content, such rights are either (A) controlled by a United States performing rights organization (e.g. ASCAP, BMI, SESAC or GMR), (B) controlled by User, not available from a performing rights society, and hereby assigned to Company, or (C) in the public domain;</div>

                                    </div>

                                    <div className="AboutDrawerDesc">
                                        EQUITABLE RELIEF:<br />
                                        User hereto acknowledges and agrees that:<br />
                                    </div>

                                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'flex-start', width: '95%', alignSelf: 'center', marginLeft: '2.5em' }}>
                                        <div className="AboutDrawerDesc" style={{ width: '3%', alignSelf: 'flex-start' }}>1.</div>
                                        <div className="AboutDrawerDesc" style={{ width: '90%' }}>the rights granted to Company, and the services to be performed, by User pursuant to the Agreement, as amended hereby, are of a special, unique, intellectual and extraordinary character which gives them peculiar value, and that if User breaches any term of the Agreement, as amended hereby, Company will be caused irreparable injury which cannot adequately be compensated by money damages, and Company will be entitled to equitable relief, including injunctive relief, to enforce the provisions of such agreements, in addition to all other remedies that Company may have, to enforce the Agreement, as amended hereby, and protect Company right thereunder; and</div>

                                    </div>

                                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'flex-start', width: '95%', alignSelf: 'center', marginLeft: '2.5em' }}>
                                        <div className="AboutDrawerDesc" style={{ width: '3%', alignSelf: 'flex-start' }}>2.</div>
                                        <div className="AboutDrawerDesc" style={{ width: '90%' }}>In the event of any breach or alleged breach of this Agreement by Company, User acknowledges and agrees that it shall be limited to an action at law for monetary damages, if any, and will not have the right to seek to enjoin or restrain the exhibition, distribution, other exploitation, advertising, promotion, publicizing, or marketing of any User Content delivered to any applicable Third Party or any content embodying such User Content.</div>

                                    </div>


                                </div>





                            }

                            {
                                DetailsDrawer === 2 &&
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <div className="SubmitionDrawerHeader">
                                        {t('SubmittedHeader')}
                                    </div>
                                    <div style={{ display: 'flex', flexDirection: 'row', width: '89%', justifyContent: 'space-between', marginLeft: '1.7em', marginTop: '1.5em', marginBottom: '1.5em' }}>
                                        <div className="SumittedtrackName">Now or Never</div>
                                        <div className="SumittedtrackDate">08/21/2023</div>
                                    </div>

                                    <div style={{ display: 'flex', flexDirection: 'row', width: '89%', justifyContent: 'space-between', marginLeft: '1.7em', marginTop: '1.5em', marginBottom: '1.5em' }}>
                                        <div className="SumittedtrackName">Twist</div>
                                        <div className="SumittedtrackDate">08/21/2023</div>
                                    </div>
                                </div>
                            }
                        </div>

                        <div style={{ width: '45.97%', maxHeight: '10.93em', backgroundImage: 'linear-gradient(174.92deg, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.03%, rgba(204, 204, 255, 0.08) 2.04%, rgba(204, 204, 255, 0.04) 91.48%)', borderRadius: '8px', marginTop: '1.5em', marginLeft: '1em' }}>
                            <div className="SubmitBtn" style={{ cursor: 'pointer' }} onClick={() => setSTPopup1(true)}>
                                {t('Submittedyourtrack')}
                            </div>

                            <div className="SubmitTrackDisclaimer">
                                {t('Submittedtracksmustbedist')}
                            </div>
                        </div>
                    </div>
                </div>
            }



        </div>

    );
}

export default Exclusives;